export function filterArtikelSuggestions(
  values: string[],
  query: string,
  limit = 50,
): string[] {
  const q = query.trim().toLowerCase();
  const filtered = q
    ? values.filter((value) => value.toLowerCase().includes(q))
    : values;
  return filtered.slice(0, limit);
}
